import React, { useMemo } from 'react';
import { Menu, MenuItem, withStyles } from '@material-ui/core';
import { generatePath, useHistory } from 'react-router';
import { URLS } from 'app/config/urls';
import { useDispatch } from 'react-redux';
import { LINES_SITUATIONS } from 'app/config/services';
import { setDuplicatedRegistry } from '../../../store/slices/line';

export const LineList = ({ open, anchorEl, handleClose, dataId, isStrip }) => {
  const history = useHistory();
  const cdLinha = dataId;

  const handleActionByType = type => {
    let tempLink = '';
    switch (type) {
      case 'edit': tempLink = URLS.LINES_MANAGE_EDIT; break;
      case 'schedules': tempLink = URLS.LINES_MANAGE_SCHEDULES; break;
      case 'intineraries': tempLink = URLS.LINES_MANAGE_ITINERARIES; break;
      case 'permissionaries': tempLink = URLS.LINES_MANAGE_PERMISSIONARIES; break;
      case 'fares': tempLink = URLS.LINES_MANAGE_FARES; break;
      case 'transfers': tempLink = URLS.LINES_MANAGE_TRANSFERS; break;
      case 'conductors': tempLink = URLS.LINES_MANAGE_CONDUCTORS; break;
      case 'contract': tempLink = URLS.LINES_MANAGE_CONTRACT; break;
      case 'apostille': tempLink = URLS.LINES_MANAGE_APOSTILLE; break;
      default: return;
    }

    const params = { cdLinha };
    if(isStrip) params.isStrip = 'strip';
    return history.push(generatePath(tempLink, params));
  };

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      <StyledMenuItem onClick={() => handleActionByType('edit')}>Editar linha</StyledMenuItem>
      {isStrip && <StyledMenuItem onClick={() => handleActionByType('contract')}>Contrato/Termo de Permissão</StyledMenuItem>}
      {!isStrip && <StyledMenuItem onClick={() => handleActionByType('permissionaries')}>Permissionário(s)</StyledMenuItem>}
      <StyledMenuItem onClick={() => handleActionByType('intineraries')}>Itinerário</StyledMenuItem>
      {isStrip && <StyledMenuItem onClick={() => handleActionByType('apostille')}>Apostila</StyledMenuItem>}
      {!isStrip && <StyledMenuItem onClick={() => handleActionByType('fares')}>Tarifa</StyledMenuItem>}
      <StyledMenuItem onClick={() => handleActionByType('schedules')}>Quadro de horários</StyledMenuItem>
      {!isStrip && <StyledMenuItem onClick={() => handleActionByType('conductors')}>Condutor substituto</StyledMenuItem>}
      <StyledMenuItem onClick={() => handleActionByType('transfers')}>Transferência</StyledMenuItem>
    </Menu>
  );
};

export const PermissionariesList = props => {
  const history = useHistory();

  const { open, anchorEl, handleClose, data, dataId, isActive, onClickActivate } = props;

  const handleGoToEdit = () => {
    const url = generatePath(URLS.LINES_MANAGE_PERMISSIONARIES_EDIT, {
      cdLinha: data.cdLinha,
      cdPermissionario: dataId
    });
    history.push(url);
  };

  const handleToggleActivation = () => {
    if (onClickActivate) onClickActivate();
  };
  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      {/* prettier-ignore */}
      <StyledMenuItem onClick={handleGoToEdit}>Editar</StyledMenuItem>
      <StyledMenuItem onClick={handleToggleActivation}>
        {isActive ? 'Inativar' : 'Ativar'}
      </StyledMenuItem>
    </Menu>
  );
};

export const ItinerariesList = ({ open, anchorEl, handleClose, data, dataId, isStrip, setCdToInativate, setOpenConfirmModal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const canDuplicate = useMemo(() => {
    return !!(data?.cdLinhaSituacao && data.cdLinhaSituacao === LINES_SITUATIONS.VIGENTE.code);
  },[data]);
  const canInativate = useMemo(() => {
    return (!data?.cdLinhaSituacao || data.cdLinhaSituacao !== LINES_SITUATIONS.INATIVO.code);
  },[data]);

  const handleGoToEdit = () => {
    const params = { cdLinha: data.cdLinha, cdItinerario: dataId };
    if(isStrip) params.isStrip = 'strip';
    history.push(generatePath(URLS.LINES_MANAGE_ITINERARIES_EDIT, params));
  };

  const handleGoToDuplicate = async () => {
    await dispatch(setDuplicatedRegistry(data));
    let params = { cdLinha: data.cdLinha };
    if(isStrip) params.isStrip = 'strip';
    history.push(generatePath(URLS.LINES_MANAGE_ITINERARIES_NEW, params));
  };

  const handleGoToDelete = async () => {
    if (data.cdLinhaItinerario) {
      setCdToInativate(data.cdLinhaItinerario);
      setOpenConfirmModal(true);
    }
  };

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      {/* prettier-ignore */}
      {canDuplicate && <StyledMenuItem onClick={handleGoToDuplicate}>Duplicar revisão</StyledMenuItem>}
      <StyledMenuItem onClick={handleGoToEdit}>Editar</StyledMenuItem>
      {canInativate && <StyledMenuItem onClick={handleGoToDelete}>Inativar</StyledMenuItem>}
    </Menu>
  );
};

export const SchedulesList = ({ open, anchorEl, handleClose, data, dataId, isStrip, setCdToInativate, setOpenConfirmModal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const canDuplicate = useMemo(() => {
    return !!(data?.cdLinhaSituacao && data.cdLinhaSituacao === LINES_SITUATIONS.VIGENTE.code);
  },[data]);
  const canInativate = useMemo(() => {
    return (!data?.cdLinhaSituacao || data.cdLinhaSituacao !== LINES_SITUATIONS.INATIVO.code);
  },[data]);

  const handleGoToEdit = () => {
    let params = {
      cdLinha: data.cdLinha,
      cdQuadroHorario: dataId
    };
    if(isStrip) params.isStrip = 'strip';
    history.push(generatePath(URLS.LINES_MANAGE_SCHEDULES_EDIT, params));
  };

  const handleGoToDuplicate = async () => {
    await dispatch(setDuplicatedRegistry(data));
    let params = { cdLinha: data.cdLinha };
    if(isStrip) params.isStrip = 'strip';
    history.push(generatePath(URLS.LINES_MANAGE_SCHEDULES_NEW, params));
  };

  const handleGoToDelete = async () => {
    if (data.cdLinhaQuadroHorario) {
      setCdToInativate(data.cdLinhaQuadroHorario);
      setOpenConfirmModal(true);
    }
  };

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      {/* prettier-ignore */}
      {canDuplicate && <StyledMenuItem onClick={handleGoToDuplicate}>Duplicar revisão</StyledMenuItem>}
      <StyledMenuItem onClick={handleGoToEdit}>Editar</StyledMenuItem>
      {canInativate && <StyledMenuItem onClick={handleGoToDelete}>Inativar</StyledMenuItem>}
    </Menu>
  );
};

export const ConductorsList = ({ open, anchorEl, handleClose, data, isActive, dataId, onClickActivate }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const canDuplicate = useMemo(() => {
    return !!(data?.cdLinhaSituacao && data.cdLinhaSituacao === LINES_SITUATIONS.VIGENTE.code);
  },[data]);

  const handleGoToEdit = () => {
    const url = generatePath(URLS.LINES_MANAGE_CONDUCTORS_EDIT, {
      cdLinha: data.cdLinha,
      cdCondutorSubstituto: dataId
    });
    history.push(url);
  };

  const handleGoToDuplicate = async () => {
    await dispatch(setDuplicatedRegistry(data));
    const url = generatePath(URLS.LINES_MANAGE_CONDUCTORS_NEW, {
      cdLinha: data.cdLinha,
    });
    history.push(url);
  };

  const handleToggleActivation = () => {
    if (onClickActivate) onClickActivate();
  };

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      {/* prettier-ignore */}
      {canDuplicate && <StyledMenuItem onClick={handleGoToDuplicate}>Duplicar</StyledMenuItem>}
      <StyledMenuItem onClick={handleGoToEdit}>Editar</StyledMenuItem>
      <StyledMenuItem onClick={handleToggleActivation}>{isActive ? 'Inativar' : 'Ativar'}</StyledMenuItem>
    </Menu>
  );
};

export const ApostilleList = ({ open, anchorEl, handleClose, data, isActive, dataId, onClickActivate, isStrip }) => {
  const history = useHistory();
  const canInativate = useMemo(() => {
    return (!data?.cdLinhaSituacao || data.cdLinhaSituacao !== LINES_SITUATIONS.INATIVO.code);
  },[data]);

  const handleGoToEdit = () => {
    const params = { cdLinha: data.cdLinha, cdLinhaApostila: dataId };
    if(isStrip) params.isStrip = 'strip';
    history.push(generatePath(URLS.LINES_MANAGE_APOSTILLE_EDIT, params));
  };

  const handleToggleActivation = () => {
    if (onClickActivate) onClickActivate();
  };

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      <StyledMenuItem onClick={handleGoToEdit}>Editar</StyledMenuItem>
      {canInativate && <StyledMenuItem onClick={handleToggleActivation}>{isActive ? 'Inativar' : 'Ativar'}</StyledMenuItem>}
    </Menu>
  );
};

export const ContractList = ({ open, anchorEl, data, handleClose, dataId, isStrip }) => {
  const history = useHistory();

  const handleGoToEdit = () => {
    const params = { cdLinha: data.cdLinha, cdContratoTermoAditivo: dataId };
    if(isStrip) params.isStrip = 'strip';
    history.push(generatePath(URLS.LINES_MANAGE_CONTRACT_EDIT, params));
  };

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
      <StyledMenuItem onClick={handleGoToEdit}>Editar/Visualizar</StyledMenuItem>
    </Menu>
  );
};

const StyledMenuItem = withStyles(() => ({
  root: {
    minWidth: 180,
  },
}))(MenuItem);
